<template>
  <div class="sidebar dinline-block vtop">
    <div class="st fs30 bg-red twhite">{{menuList.name}}</div>
    <div class="adiv fs16 tleft">
      <router-link v-for="(child,index) in menuList.children" :key="index"
                   :to="{path:child.to,query:{id:index,pid:pid}}"
                   :class="{active:index==$route.query.id}"
                   class="bborder dblock">{{child.name}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Left",
  props:[
    'pid'
  ],
  data(){
    return {
      menu:{}
    }
  },
  created() {
    this.$request.get('get-columns', [], response => {
        if (response.status == 200) {
          this.menu = response.data;
        } else {
          console.error("获取数据失败");
        }
      },
      (error) => {
        console.error("请求发生错误:", error);
      });
  },
  computed:{
    menuList:function () {
      return this.menu[this.pid]
    }
  }
}
</script>

<style scoped>
.active{
  font-weight: bold;
  background: url(../../assets/images/cn1.png) no-repeat 27px -1213px;
}
</style>



// WEBPACK FOOTER //
// src/components/un_index/Left.vue